// Generated by tools/gen-backend-hooks.ts — do not edit by hand.
// One hook per endpoint in backend/inventoryPage/.

import { makeBackendHook } from './_client'

export type { BackendQuery, TriggerOptions } from './_client'

/** POST /api/rpc/inventoryPage/cleanupProductPhoto */
export const useCleanupProductPhoto = makeBackendHook('inventoryPage', 'cleanupProductPhoto')

/** POST /api/rpc/inventoryPage/combineProductPhotos */
export const useCombineProductPhotos = makeBackendHook('inventoryPage', 'combineProductPhotos')

/** POST /api/rpc/inventoryPage/getAvailableSku */
export const useGetAvailableSku = makeBackendHook('inventoryPage', 'getAvailableSku')

/** POST /api/rpc/inventoryPage/getAvailableSkuStats */
export const useGetAvailableSkuStats = makeBackendHook('inventoryPage', 'getAvailableSkuStats')

/** POST /api/rpc/inventoryPage/getAvailableSkus */
export const useGetAvailableSkus = makeBackendHook('inventoryPage', 'getAvailableSkus')

/** POST /api/rpc/inventoryPage/getOpenOrders */
export const useGetOpenOrders = makeBackendHook('inventoryPage', 'getOpenOrders')

/** POST /api/rpc/inventoryPage/getPhotoOriginals */
export const useGetPhotoOriginals = makeBackendHook('inventoryPage', 'getPhotoOriginals')

/** POST /api/rpc/inventoryPage/getProducts */
export const useGetProducts = makeBackendHook('inventoryPage', 'getProducts')

/** POST /api/rpc/inventoryPage/getSeasonalAlerts */
export const useGetSeasonalAlerts = makeBackendHook('inventoryPage', 'getSeasonalAlerts')

/** POST /api/rpc/inventoryPage/handleSeasonalAlert */
export const useHandleSeasonalAlert = makeBackendHook('inventoryPage', 'handleSeasonalAlert')

/** POST /api/rpc/inventoryPage/importAvailableSkus */
export const useImportAvailableSkus = makeBackendHook('inventoryPage', 'importAvailableSkus')

/** POST /api/rpc/inventoryPage/incrementProductStockBySku */
export const useIncrementProductStockBySku = makeBackendHook('inventoryPage', 'incrementProductStockBySku')

/** POST /api/rpc/inventoryPage/postProductLabels */
export const usePostProductLabels = makeBackendHook('inventoryPage', 'postProductLabels')

/** POST /api/rpc/inventoryPage/publishLabelProducts */
export const usePublishLabelProducts = makeBackendHook('inventoryPage', 'publishLabelProducts')

/** POST /api/rpc/inventoryPage/updateProductsBulk */
export const useUpdateProductsBulk = makeBackendHook('inventoryPage', 'updateProductsBulk')

/** POST /api/rpc/inventoryPage/updateProductsFieldsBulk */
export const useUpdateProductsFieldsBulk = makeBackendHook('inventoryPage', 'updateProductsFieldsBulk')

/** POST /api/rpc/inventoryPage/uploadProductPhoto */
export const useUploadProductPhoto = makeBackendHook('inventoryPage', 'uploadProductPhoto')

/** POST /api/rpc/inventoryPage/upsertProduct */
export const useUpsertProduct = makeBackendHook('inventoryPage', 'upsertProduct')

/** POST /api/rpc/inventoryPage/writeProductDescriptions */
export const useWriteProductDescriptions = makeBackendHook('inventoryPage', 'writeProductDescriptions')
